import React, { useState } from 'react';
import { Button, Row, Col } from 'antd';
import Login from './login';
import Register from './register';
import { useNavigate } from 'react-router-dom';


export default function AuthPage({ setHasLoggedIn }) {
  const [isLoginPage, setIsLoginPage] = useState(true);


  const handleToggle = () => {
    setIsLoginPage((prev) => !prev);
  };
 
  return (
    <Row justify="center" align="middle" style={{ minHeight: '90vh', width: '100%' }}>
      <Col xs={10} >
        <div style={{ padding: 24, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          {isLoginPage ?
            <Login setHasLoggedIn={setHasLoggedIn} />
            : <Register setHasLoggedIn={setHasLoggedIn} />}
          <Button
            type="link"
            block
            style={{ marginTop: 16 }}
            onClick={handleToggle}
          >
            {isLoginPage ? 'Or Register' : 'Or Login'}
          </Button>
        </div>
      </Col>
    </Row>
  );
}